export const prefix = 'Organization';
export var Type;
(function (Type) {
    Type["Create"] = "Create";
    Type["Delete"] = "Delete";
    Type["ProfileUpdate"] = "Profile.Update";
    Type["BrandingUpdate"] = "Branding.Update";
    Type["MemberAdd"] = "Member.Add";
    Type["MemberRemove"] = "Member.Remove";
    Type["BusinessRoleUpdate"] = "BusinessRole.Update";
    Type["OwnerAssign"] = "Owner.Assign";
    Type["OwnerRemove"] = "Owner.Remove";
    Type["ManagementRoleCreate"] = "ManagementRole.Create";
    Type["ManagementRoleUpdate"] = "ManagementRole.Update";
    Type["ManagementRoleDelete"] = "ManagementRole.Delete";
    Type["ManagementRoleAssign"] = "ManagementRole.Assign";
    Type["ManagementRoleUnassign"] = "ManagementRole.Unassign";
    Type["InvitationCreate"] = "Invitation.Create";
    Type["InvitationAccept"] = "Invitation.Accept";
    Type["InvitationDecline"] = "Invitation.Decline";
    Type["InvitationRevoke"] = "Invitation.Revoke";
    Type["SecurityUpdate"] = "Security.Update";
    Type["JitUpdate"] = "Jit.Update";
    Type["DomainVerification"] = "Domain.Verification";
    Type["ApplicationUpdate"] = "Application.Update";
})(Type || (Type = {}));
